import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vShow as _vShow, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { id: "photo-gallery" };
const _hoisted_2 = { class: "gallery-images" };
const _hoisted_3 = ["onClick"];
const _hoisted_4 = ["src", "alt"];
const _hoisted_5 = {
    class: "overlay-content",
    ref: "currentImgEle"
};
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("div", { class: "image" }, [
    /*#__PURE__*/ _createElementVNode("img", {
        src: "",
        alt: "Current Image"
    })
], -1 /* HOISTED */);
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("img", {
    src: "/images/close_icon.svg",
    alt: "Close Button"
}, null, -1 /* HOISTED */);
const _hoisted_8 = [
    _hoisted_7
];
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("img", {
    src: "/images/gallery-right-arrow.svg",
    alt: ""
}, null, -1 /* HOISTED */);
const _hoisted_10 = [
    _hoisted_9
];
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("img", {
    src: "/images/gallery-left-arrow.svg",
    alt: ""
}, null, -1 /* HOISTED */);
const _hoisted_12 = [
    _hoisted_11
];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _directive_touch = _resolveDirective("touch");
    return (_openBlock(), _createElementBlock("main", _hoisted_1, [
        _createElementVNode("menu", null, [
            _createElementVNode("h1", null, _toDisplayString(_ctx.title), 1 /* TEXT */)
        ]),
        _createElementVNode("figure", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.imageList, (image, index) => {
                return (_openBlock(), _createElementBlock("picture", {
                    key: index,
                    onClick: ($event) => (_ctx.showPicture(index))
                }, [
                    _createElementVNode("img", {
                        src: image.uri,
                        alt: `image #${index} for gallery ${_ctx.title}`
                    }, null, 8 /* PROPS */, _hoisted_4)
                ], 8 /* PROPS */, _hoisted_3));
            }), 128 /* KEYED_FRAGMENT */))
        ]),
        _withDirectives(_createElementVNode("div", {
            class: "overlay",
            onClick: _cache[3] || (_cache[3] = _withModifiers(($event) => (_ctx.showOverlay = !_ctx.showOverlay), ["self"]))
        }, [
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [
                _hoisted_6,
                _createElementVNode("div", {
                    class: "close-btn",
                    onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.showOverlay = !_ctx.showOverlay))
                }, _hoisted_8),
                _createElementVNode("div", {
                    class: "next-btn",
                    onClick: _cache[1] || (_cache[1] =
                        //@ts-ignore
                        (...args) => (_ctx.next && _ctx.next(...args)))
                }, _hoisted_10),
                _createElementVNode("div", {
                    class: "prev-btn",
                    onClick: _cache[2] || (_cache[2] =
                        //@ts-ignore
                        (...args) => (_ctx.prev && _ctx.prev(...args)))
                }, _hoisted_12)
            ])), [
                [
                    _directive_touch,
                    _ctx.next,
                    "swipe",
                    { left: true }
                ],
                [
                    _directive_touch,
                    _ctx.prev,
                    "swipe",
                    { right: true }
                ]
            ])
        ], 512 /* NEED_PATCH */), [
            [_vShow, _ctx.showOverlay]
        ])
    ]));
}
